import apiConfig from '../../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const getConfigAssets = async (userId) => {
  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) {throw new Error('No token found');}

    const response = await fetch(`${api_base_url}/api/${api_key}/get/${userId}/aws/configAsset`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.error === 'Token expired') {
        alert('Your session has expired. Please log in again.');
      } else {
        throw new Error(errorData.error || 'Failed to fetch user profile');
      }
    }
 
    return response.json();
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
}

export const getConfigScanProgress = async (userId) => {
  const token = sessionStorage.getItem('authToken');
  if (!token) throw new Error('No token found');

  const response = await fetch(
    `${api_base_url}/api/${api_key}/get/${userId}/aws/configProgress`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    }
  );
  const data = await response.json();
  if (!response.ok || data.success === false) {
    throw new Error(data.message || data.error || 'Unable to read scan progress');
  }
  return data.data;
};
